// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__27nP2","requiredAsterisk":"Info_requiredAsterisk__jM5be"};